import { Outlet } from 'react-router-dom';
import UserProfile from './UserProfile';
import Footer from './Footer';
import HoitoLogo from './HoitoLogo';

export default function Layout() {
  return (
    <div className="min-h-screen bg-white text-slate-900 antialiased font-sans">
      <header className="sticky top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-slate-200/80">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-14 sm:h-16">
            <HoitoLogo href="/dashboard" showText={true} />
            <UserProfile />
          </div>
        </div>
      </header>

      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
}
